import {defineStore} from "pinia";
import * as signalR from "@microsoft/signalr";
import {useAuthStore} from "@/stores/authentication-store";
import {SignalRConnectionStatus} from "@/constants/signalr-connection";
import {initializeSignalrConnection} from "@/stores/signalr/signalr-handlers";

const portalUrl: string = "portal";

interface SignalRState {
    signalRConnection: signalR.HubConnection | null;
    connectionState: SignalRConnectionStatus,
    connectionId: string | null,
}

export const useSignalRStore = defineStore({
    id: 'signalr-store',
    state: () => ({
        signalRConnection: null,
        connectionState: SignalRConnectionStatus.Disconnected,
        connectionId: null,
    } as SignalRState),
    actions: {
        async Connect() {
            try {
                const authStore = useAuthStore();

                if (this.signalRConnection !== null || !authStore.isAuthenticated()) return;
                
                this.signalRConnection = new signalR.HubConnectionBuilder()
                    .withUrl(`${import.meta.env.VITE_API_API_URL}${portalUrl}`, {
                        transport: signalR.HttpTransportType.WebSockets,
                        skipNegotiation: false,
                    })
                    .withAutomaticReconnect()
                    .build();

                this.signalRConnection.onreconnecting(() => {
                    this.connectionState = SignalRConnectionStatus.Reconnecting;
                });

                this.signalRConnection.onreconnected(() => {
                    this.connectionState = SignalRConnectionStatus.Connected;
                })

                this.signalRConnection.onclose(() => {
                    this.connectionState = SignalRConnectionStatus.Disconnected;
                })

                this.signalRConnection.on("send_connection_id", async (connectionId: string) => {
                    this.connectionId = connectionId;
                })

                // @ts-ignore
                initializeSignalrConnection(this.signalRConnection);

                await this.signalRConnection.start();
                this.connectionState = SignalRConnectionStatus.Connected;

            } catch (err) {
                this.connectionState = SignalRConnectionStatus.Disconnected;
            }
        },
        GetConnectionId() {
            if (!this.signalRConnection || this.connectionState !== SignalRConnectionStatus.Connected) return "";
            return this.connectionId;
        }
    }
})
